import Swiper from 'swiper';
import {Navigation, EffectFade} from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import {initVideoPlayer} from './videoPlayer';

document.querySelectorAll('[data-slider]').forEach(slider => {

    const options = {
      modules: [Navigation, EffectFade],
      loop: false,
      autoHeight: true,
      allowTouchMove: true,
      navigation: {
        nextEl: slider.querySelector('.slider-button-next'),
        prevEl: slider.querySelector('.slider-button-prev'),
      },
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
    }

    const swiper = new Swiper(slider.querySelector('.swiper'), options);

    // Gallery slides can hold a native <video> or an embedded iframe. Enhance
    // each one with the same Plyr player as the video/embed blocks. Slides
    // carry no [data-video] hook, so videoPlayer's auto-init skips them — we
    // init per-slide here instead.
    let hasPlayer = false;
    slider.querySelectorAll('.swiper-slide').forEach(slide => {
      if (slide.querySelector('video, .plyr__video-embed')) {
        initVideoPlayer(slide);
        hasPlayer = true;
      }
    });

    // Plyr changes slide height once its player DOM is in place; recompute so
    // autoHeight accounts for the players.
    if (hasPlayer) swiper.update();

    // Don't hijack clicks on interactive elements (copyright links, buttons)
    // or on a video player — clicks there control the player, not the slider.
    const isInteractive = target => target.closest('a, button, video, iframe, .plyr');

    // Click left half of the slide → previous, right half → next. Uses Swiper's
    // own `click` event, which is suppressed after a swipe/drag and only fires
    // on genuine taps/clicks, so it never conflicts with touch swiping.
    swiper.on('click', (sw, event) => {
      if (isInteractive(event.target)) return;
      const rect = sw.el.getBoundingClientRect();
      const goPrev = (event.clientX - rect.left) < rect.width / 2;
      goPrev ? sw.slidePrev() : sw.slideNext();
    });
  }
)
